import { render, staticRenderFns } from "./LegalsView.html?vue&type=template&id=72a6270d&scoped=true&"
import script from "./LegalsView.js?vue&type=script&lang=js&"
export * from "./LegalsView.js?vue&type=script&lang=js&"
import style0 from "./LegalsView.scss?vue&type=style&index=0&id=72a6270d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6270d",
  null
  
)

component.options.__file = "LegalsView.vue"
export default component.exports